import wx from "weixin-js-sdk";
let u = navigator.userAgent;
let isWX = u.indexOf("MicroMessenger") > -1;
let isMini = () =>
  new Promise((resolve, reject) => {
    if (!isWX) {
      resolve(false);
    } else {
      wx.miniProgram.getEnv(env => {
        resolve(env.miniprogram);
      });
    }
  });
let isIPhoneXOrAbove = false;
if (u.match(/iPhone/i) && screen.height >= 724 && screen.width >= 375) {
  isIPhoneXOrAbove = true;
}

let envs = {
  // 移动终端浏览器版本信息
  tui: u.indexOf("T-UI") > -1, // 天高混合内核
  trident: u.indexOf("Trident") > -1, // IE内核
  presto: u.indexOf("Presto") > -1, // opera内核
  webKit: u.indexOf("AppleWebKit") > -1, // 苹果、谷歌内核
  gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") === -1, // 火狐内核
  mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
  ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
  android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, // android终端或者uc浏览器
  iPhone: u.indexOf("iPhone") > -1, // 是否为iPhone或者QQHD浏览器
  iPad: u.indexOf("iPad") > -1, // 是否iPad
  webApp: u.indexOf("Safari") === -1, // 是否web应用程序，没有头部与底部
  weChat: isWX, // 微信浏览器,
  isMini: isMini(),
  Ali: u.indexOf("AliApp") > -1 ,// 是否支付宝
  isIPhoneXOrAbove: isIPhoneXOrAbove,// 是否为苹果X及以上手机
  androidDevice: u.indexOf("Android") > -1, // 是否为安卓设备
};



export default {
  versions: envs,
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
};



// WEBPACK FOOTER //
// ./src/utils/browser.js